import React, { useEffect, useState } from 'react';
import styles from '../../formStyles.module.css';
import FormItem from '@/components/common/FormItem';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import Api from '@/api';

export default function TicketFormInfo({ info, setInfo, modalKey }) {
  const tCommon = useTranslations('common');
  let formarray = [
    {
      id: 1,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: tCommon('title'),
      title: tCommon('title'),
      error: info?.messages?.title,
      // extraInfo: ' * ',
      // styleColor: `starColor`,
      showError: info?.error?.title,
      value: info?.title,
      key: 'title',
      // wrapper: `darkInput`,
    },
    {
      id: 2,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: tCommon('address'),
      title: tCommon('address'),
      error: info?.messages?.addressLine1,
      value: info?.addressLine1,
      showError: info?.error?.addressLine1,
      error: info?.messages?.addressLine1,
      key: 'addressLine1',
      // wrapper: `darkInput`,
    },
    // {
    //   id: 3,
    //   type: 'input',
    //   placeholder: tCommon('address') + 2,
    //   title: tCommon('address') + 2,
    //   error: info?.messages?.addressLine2,
    //   value: info?.addressLine2,
    //   showError: info?.error?.addressLine2,
    //   error: info?.messages?.addressLine2,
    //   key: 'addressLine2',
    //   // wrapper: `darkInput`,
    // },
    {
      type: 'myselectSort',
      id: 'country',
      // extraInfo: '*',
      // styleColor: 'starColor',
      // classMain: ` ${styles.wfull} ${styles.itemMargin}`,
      key: 'country',
      value: info?.country || null,
      error: info?.messages?.country,
      showError: info?.error?.country,
      apiCategory: [
        {
          id: 1,
          searchkey: 'q',
          listTitleKey: ['name'],
          apiParams: { start: 0, limit: 10 },
          apiCall: Api.countryList,
          placeholder: tCommon('country'),
          title: tCommon('country'),
        },
      ],
    },
    {
      type: 'myselectSort',
      id: 'province',
      // extraInfo: '*',
      // styleColor: 'starColor',
      // classMain: ` ${styles.wfull} ${styles.itemMargin}`,
      key: 'province',
      value: info?.province || null,
      error: info?.messages?.province,
      showError: info?.error?.province,
      disabled: !info?.country?.id,
      apiCategory: [
        {
          id: 1,
          searchkey: 'q',
          listTitleKey: ['name'],
          apiParams: { start: 0, limit: 10, countryId: info?.country?.id },
          apiCall: Api.provinceList,
          placeholder: tCommon('province'),
          title: tCommon('province'),
        },
      ],
    },
    {
      type: 'myselectSort',
      id: 'city',
      // extraInfo: '*',
      // styleColor: 'starColor',
      classMain: ` ${styles.wfull} ${styles.itemMargin}`,
      key: 'city',
      value: info?.city || null,
      disabled: !info?.province?.id,
      error: info?.messages?.city,
      showError: info?.error?.city,
      apiCategory: [
        {
          id: 1,
          searchkey: 'q',
          listTitleKey: ['name'],
          apiParams: { start: 0, limit: 10, provinceId: info?.province?.id },
          apiCall: Api.cityList,
          placeholder: tCommon('city'),
          title: tCommon('city'),
        },
      ],
    },
    {
      id: 6,
      type: 'input',
      // extraInfo: '*',
      // styleColor: 'starColor',
      placeholder: tCommon('postalCode'),
      title: tCommon('postalCode'),
      error: info?.messages?.postalCode,
      value: info?.postalCode,
      showError: info?.error?.postalCode,
      error: info?.messages?.postalCode,
      key: 'postalCode',
      // wrapper: `darkInput`,
    },
    {
      id: 4,
      type: 'input',
      // extraInfo: '*',
      // styleColor: 'starColor',
      placeholder: tCommon('lat'),
      title: tCommon('lat'),
      error: info?.messages?.lat,
      value: info?.lat,
      showError: info?.error?.lat,
      error: info?.messages?.lat,
      key: 'lat',
      // wrapper: `darkInput`,
    },
    {
      id: 5,
      type: 'input',
      // extraInfo: '*',
      // styleColor: 'starColor',
      placeholder: tCommon('long'),
      title: tCommon('long'),
      error: info?.messages?.long,
      value: info?.long,
      showError: info?.error?.long,
      error: info?.messages?.long,
      key: 'long',
      // wrapper: `darkInput`,
    },

    {
      id: 9,
      type: 'textarea',
      placeholder: tCommon('notes'),
      title: tCommon('notes'),
      error: info?.messages?.notes,
      value: info?.notes,
      showError: info?.error?.notes,
      error: info?.messages?.notes,
      key: 'notes',
      // wrapper: `darkInput`,
      extraWrapperClass: `${styles.checkbox}`,
    },
    {
      id: 7,
      type: 'toggle',
      placeholder: tCommon('isDefault'),
      title: tCommon('isDefault'),
      error: info?.messages?.isDefault,
      value: info?.isDefault,
      showError: info?.error?.isDefault,
      error: info?.messages?.isDefault,
      key: 'isDefault',
      // wrapper: `darkInput`,
      className: styles.checkbox,
    },
  ];

  const [formList, setFormList] = useState(formarray);

  useEffect(() => {
    if (info) {
      setFormList(formarray);
    }
  }, [info]);

  const onChange = (value, key) => {
    let valueIs = {
      ...info,
      [key]: value,
      error: {
        ...info?.error,
        [key]: false,
      },
    };
    if (key == 'country') {
      valueIs.province = null;
      valueIs.city = null;
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }
    if (key == 'province') {
      valueIs.city = null;
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }
    if (key == 'city') {
      valueIs.latitude = value.lat || '';
      valueIs.longitude = value.long || '';
      valueIs.error.latitude = false;
      valueIs.error.longitude = false;
    }

    setInfo(valueIs);
  };

  console.log('info==', info);

  return (
    <div className={`${styles.formContainer}`}>
      {formList?.map((item, index) => (
        <FormItem
          type={item.type}
          inputType={item.inputType}
          key={index}
          item={item}
          index={index}
          onChange={onChange}
          value={info?.[`${item?.key}`]}
        ></FormItem>
      ))}
    </div>
  );
}
